/**
 * In-app route builders for the configurator-v0 wizard (the short flow).
 *
 * The wizard is mounted full-bleed under `CONFIGURATOR_BASE` as a fixed React
 * route (see router.tsx + src/routes.tsx). Steps: `/theme`, `/colors`, `/review`,
 * `/payment` (Features + Players are skipped in this flow).
 */
import { CONFIGURATOR_BASE } from './store/configurator';

export const CONFIGURATOR_ROUTE = {
  base: (): string => CONFIGURATOR_BASE,
  theme: (): string => `${CONFIGURATOR_BASE}/theme`,
  colors: (): string => `${CONFIGURATOR_BASE}/colors`,
  review: (): string => `${CONFIGURATOR_BASE}/review`,
  payment: (): string => `${CONFIGURATOR_BASE}/payment`,
} as const;
